import { Directive, HostListener } from "@angular/core";
@Directive({
  standalone: false,
  // tslint:disable-next-line:directive-selector
  selector: "[MaxLengthValidate]",
})
// tslint:disable-next-line:directive-class-suffix
export class MaxLengthValidate {
  @HostListener("keypress", ["$event"])
  onkeypress(event: any) {
    if(event && event.target.value.toString().length > 10) {
      event.stopPropagation();
      return false;
    }
  }
}
